/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import * as Yup from 'yup';
const nameValidation = (
  max: number = Infinity,
  matches: RegExp = /.*/,
  required: boolean = false,
  message: string = "name"
) =>
  Yup.string()
    .max(max, `Maximum ${max} characters allowed in ${message}`)
    .matches(matches, `Only valid characters are allowed in ${message}`)
    .required(required ? `${message} is required` : undefined);

const minMaxValidation = (min: number, max: number, message?: string) =>
  Yup.string()
    .min(min, `Minimum ${min} characters allowed`)
    .max(max, `Maximum ${max} characters allowed`)
    .required(`Enter Your ${message}`);
 export const ingredientSchema = Yup.object().shape({
  name: nameValidation(50, /^[a-zA-Z\s]+$/, true, "Ingredient Name"),
});

    

